// extracted by mini-css-extract-plugin
export default {"container":"Lightbox-module__container-mZAwnu","open":"Lightbox-module__open-wXafMa","image":"Lightbox-module__image-j4cfWH","backdrop":"Lightbox-module__backdrop-V2ZPHe"};